/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Component, HostListener, Optional} from '@angular/core';
import {VerticalNavGroupService} from './providers/vertical-nav-group.service';
export class VerticalNavLink {
/**
 * @param {?} _navGroupService
 */
constructor(
private _navGroupService: VerticalNavGroupService) {}
/**
 * @return {?}
 */
private expandParentNavGroup(): void {
        if (this._navGroupService) {
            this._navGroupService.expand();
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "[clrVerticalNavLink]",
    template: `
        <ng-content select="[clrVerticalNavIcon]"></ng-content>
        <span class="nav-text">
            <ng-content></ng-content>    
        </span>
    `,
    host: {"class": "nav-link"}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: VerticalNavGroupService, decorators: [{ type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'expandParentNavGroup': [{ type: HostListener, args: ["click", ] },],
};
}

function VerticalNavLink_tsickle_Closure_declarations() {
/** @type {?} */
VerticalNavLink.decorators;
/**
 * @nocollapse
 * @type {?}
 */
VerticalNavLink.ctorParameters;
/** @type {?} */
VerticalNavLink.propDecorators;
/** @type {?} */
VerticalNavLink.prototype._navGroupService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
